<template lang="pug">
div
  .md-form-group
    label Search
    input(
      type="text"
      name="search"
      v-model="search"
      @input="onFiltersChange"
      class="form-control"
      :disabled="!planograms.length"
    )
  .md-form-group
    label Planogram Name
    multiselect(
      :loading="onLoading('fetch-planogram-list')"
      name="planogram"
      deselect-label=""
      label="name"
      select-label=""
      track-by="id"
      v-model="planograms"
      :close-on-select="false"
      :hide-selected="true"
      :multiple="true"
      :options="list"
      @input="onFiltersChange"
    )
     template(slot="tag" slot-scope="{ option, remove }")
      span.multiselect__tag 
        span(v-tooltip.top-center="option.name") {{ option.name }}
        span(v-if="option.name !== null" ) 
        i(class="multiselect__tag-icon", aria-hidden="true", tabindex="1" @click="remove(option)")
  .md-form-group
    label Dimension
    select(
      class="form-control c-select" 
      v-model="dimension"
      @change="onDimensionChange"
    )
      option(:value="null") Select option
      optgroup(v-for="(group, name) in groupDimensionList" :label="name")
        option(
            v-for="data in group"
            :value="data.id"
            :key="data.id")
            | {{ data.name }}
     
  div(v-if="this.dimension === 4")
   .md-form-group
    label Select Margin Small
    select(class="form-control c-select" v-model="selectedSmall" @change="toggleTextField" :disabled="isMarginDisabled")
      option(value="" disabled selected) Please Select
      option(value="option1") W: 3cm H : 1.8cm
      option(value="option2") W: 2.9cm H: 1.8cm
      option(value="option3") W: 2.8cm H: 1.8cm
      option(value="option4") W: 2.7cm H: 1.8cm
      option(value="others") Custom Values

    label(class="m-t" v-if="showSmallTextField === true") Left
      input(v-if="showSmallTextField === true" v-model.number="leftMargin" type="number" class="form-control" placeholder="Enter value in cm" @input="onMarginSelectionOptionChange" )
      label(class="text-warning" v-if="showErrorMessageExceedMargin === true") Exceeds maximum recommended left margin of 3cm
    label(class="m-t" v-if="showSmallTextField === true") Top
      input(v-if="showSmallTextField === true" v-model.number="topMargin" type="number" class="form-control" placeholder="Enter value in cm" @input="onMarginSelectionOptionChange" )
   
  div(v-if="this.dimension === 5")
   .md-form-group
    label Select Margin Standard
    select(class="form-control c-select" v-model="selectedStandard" @change="toggleTextField" :disabled="isMarginDisabled")
      option(value="" disabled selected) Please Select
      option(value="option1") W: 3.1cm H : 1.8cm
      option(value="option2") W: 3 cm H: 1.8cm
      option(value="option3") W: 2.9 cm H: 1.8cm
      option(value="option4") W: 2.8 cm H: 1.8cm 
      option(value="others") Custom Values

    label(class="m-t" v-if="showStandardTextField === true") Left
      input(v-if="showStandardTextField === true" v-model.number="leftMargin" type="number" class="form-control" placeholder="Enter value in cm" @input="onMarginSelectionOptionChange" )
      label(class="text-warning" v-if="showErrorMessageExceedMargin === true") Exceeds maximum recommended left margin of 3.1cm
    label(class="m-t" v-if="showStandardTextField === true") Top
      input(v-if="showStandardTextField === true" v-model.number="topMargin" type="number" class="form-control" placeholder="Enter value in cm" @input="onMarginSelectionOptionChange" )
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    props: {
        id: {
            type: Number,
            required: true,
        },
        updateFilters: {
            type: Function,
            required: true,
        },
        dimensionChange: {
            type: Function,
            required: true,
        },
        marginLeftChange: {
            type: Function,
            required: true,
        },
        marginTopChange: {
            type: Function,
            required: true,
        },
        marginSelectionOptionChange: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            addAll: false,
            planograms: [],
            search: null,
            dimension: null,
            selectedSmall: '',
            selectedStandard: '',
            leftMargin: '',
            topMargin: '',
            showErrorMessageExceedMargin: false,
            showSmallTextField: false,
            showStandardTextField: false,
        };
    },
    computed: {
        ...mapGetters('planogram', {
            list: 'planogramNameList',
            groupDimensionList: 'groupDimensionList',
        }),

        ...mapActions('planogram', ['getProductList']),

        isMarginDisabled() {
            return this.dimension !== 4 && this.dimension !== 5;
        },
    },
    mounted() {
        this.getList({ pricebook_id: this.id });
    },
    methods: {
        setMarginSmallForFirstOption() {
            this.leftMargin = 3;
            this.topMargin = 1.8;
        },

        setMarginSmallForSecondOption() {
            this.leftMargin = 2.9;
            this.topMargin = 1.8;
        },

        setMarginSmallForThirdOption() {
            this.leftMargin = 2.8;
            this.topMargin = 1.8;
        },

        setMarginSmallForFourthOption() {
            this.leftMargin = 2.7;
            this.topMargin = 1.8;
        },

        setMarginStandardForFirstOption() {
            this.leftMargin = 3.1;
            this.topMargin = 1.8;
        },

        setMarginStandardForSecondOption() {
            this.leftMargin = 3;
            this.topMargin = 1.8;
        },

        setMarginStandardForThirdOption() {
            this.leftMargin = 2.9;
            this.topMargin = 1.8;
        },

        setMarginStandardForFourthOption() {
            this.leftMargin = 2.8;
            this.topMargin = 1.8;
        },

        checkSmallOrStandard() {
            if (this.dimension === 5) {
                this.showStandardTextField = this.selectedStandard === 'others';
            }

            if (this.dimension === 4) {
                this.showSmallTextField = this.selectedSmall === 'others';
            }
        },

        clearSmallorStandardTextfield() {
            this.showSmallTextField == false;
            this.showStandardTextField == false;
        },

        toggleTextField() {
            this.checkSmallOrStandard();
            // handle for small
            if (this.selectedSmall === 'option1') {
                this.setMarginSmallForFirstOption();
            }

            if (this.selectedSmall === 'option2') {
                this.setMarginSmallForSecondOption();
            }

            if (this.selectedSmall === 'option3') {
                this.setMarginSmallForThirdOption();
            }

            if (this.selectedSmall === 'option4') {
                this.setMarginSmallForFourthOption();
            }

            // handle for standard
            if (this.selectedStandard == 'option1') {
                this.setMarginStandardForFirstOption();
            }

            if (this.selectedStandard == 'option2') {
                this.setMarginStandardForSecondOption();
            }

            if (this.selectedStandard == 'option3') {
                this.setMarginStandardForThirdOption();
            }

            if (this.selectedStandard == 'option4') {
                this.setMarginStandardForFourthOption();
            }

            this.onMarginSelectionOptionChange();
        },

        onFiltersChange: _.debounce(function() {
            if (!this.planograms.length) {
                this.search = null;
            }

            this.updateFilters({
                planograms: this.planograms,
                search: this.search,
            });
        }, 1000),
        onToggleChange() {
            this.onAddAllChange(this.addAll);
        },
        onDimensionChange() {
            this.clearSmallorStandardTextfield();
            this.dimensionChange(this.dimension);
        },

        onMarginSelectionOptionChange() {
            if (this.dimension === 4) {
                if (this.leftMargin > 3) {
                    this.showErrorMessageExceedMargin = true;
                } else {
                    this.showErrorMessageExceedMargin = false;
                }
            }

            if (this.dimension === 5) {
                if (this.leftMargin > 3.1) {
                    this.showErrorMessageExceedMargin = true;
                } else {
                    this.showErrorMessageExceedMargin = false;
                }
            }

            this.marginLeftChange(this.leftMargin * 10);
            this.marginTopChange(this.topMargin * 10);
            if (this.selectedSmall) {
                this.marginSelectionOptionChange(this.selectedSmall);
            }

            if (this.selectedStandard) {
                this.marginSelectionOptionChange(this.selectedStandard);
            }
        },

        ...mapActions('planogram', ['getList']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/pricebook/template/filter-sidebar-planogram.vue